import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { UserApi } from '../../../api/user-api';
import { MapService } from '../../../services/map.service';
import { BaseComponent } from '../../base.component';
var UnShareMapComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UnShareMapComponent, _super);
    function UnShareMapComponent(_vcr, authService, mapService, userApi, changeRef) {
        var _this = _super.call(this, _vcr) || this;
        _this.authService = authService;
        _this.mapService = mapService;
        _this.userApi = userApi;
        _this.changeRef = changeRef;
        _this.canViewUsers = false;
        _this.success = false;
        _this.closeUnshareMap = new EventEmitter();
        _this.registerEvent('closeUnshareMap', _this.closeUnshareMap);
        _this.authService.permissions.subscribe(function (permissions) {
            _this.canViewUsers = permissions && permissions.includes('View Users');
        });
        return _this;
    }
    Object.defineProperty(UnShareMapComponent.prototype, "map", {
        get: function () {
            return this._map;
        },
        set: function (value) {
            if (value) {
                this._map = value;
                this.getSharedUsers();
            }
        },
        enumerable: true,
        configurable: true
    });
    UnShareMapComponent.prototype.ngAfterViewInit = function () {
        this.isReady();
    };
    UnShareMapComponent.prototype.getSharedUsers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userIds, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.resetSuccess();
                        this.unSharedUsers = [];
                        userIds = this.map.sharedWith.map(function (u) { return u.userId; });
                        _a = this;
                        return [4 /*yield*/, this.userApi.getUsers(userIds, this.canViewUsers)];
                    case 1:
                        _a.sharedUsers = _b.sent();
                        this.changeRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    UnShareMapComponent.prototype.resetSuccess = function () {
        this.success = false;
        this.changeRef.detectChanges();
    };
    UnShareMapComponent.prototype.unshareUser = function (index) {
        this.unSharedUsers = tslib_1.__spread(this.unSharedUsers, this.sharedUsers.splice(index, 1));
        this.changeRef.detectChanges();
    };
    UnShareMapComponent.prototype.reshareUser = function (index) {
        this.sharedUsers = tslib_1.__spread(this.sharedUsers, this.unSharedUsers.splice(index, 1));
        this.changeRef.detectChanges();
    };
    UnShareMapComponent.prototype.unShare = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userIds;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userIds = this.unSharedUsers.map(function (u) { return u.id; });
                        return [4 /*yield*/, this.mapService.unShareMap(userIds, this.map.id)];
                    case 1:
                        _a.sent();
                        this.success = true;
                        this.unSharedUsers = [];
                        this.changeRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    UnShareMapComponent.prototype.close = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.closeUnshareMap.emit();
                return [2 /*return*/];
            });
        });
    };
    return UnShareMapComponent;
}(BaseComponent));
export { UnShareMapComponent };
